import $ from 'jquery';
import Functions from "../js/functions";
import Translate from "../js/translates";

function pad(n) {
    return (n < 10 ? '0' : '') + n;
}

function getCountdown(time, type) {
    let days, hours, minutes, seconds;
    let current_date = new Date().getTime();
    let seconds_left = (time - current_date) / 1000;

    if (parseInt(seconds_left) >= 0) {
        days = pad(parseInt(seconds_left / 86400));
        seconds_left = seconds_left % 86400;

        hours = pad(parseInt(seconds_left / 3600));
        seconds_left = seconds_left % 3600;

        minutes = pad(parseInt(seconds_left / 60));
        seconds = pad(parseInt(seconds_left % 60));
    }

    [{
        'selector': '.payment-price__days .payment-price__how',
        'value': days,
    }, {
        'selector': '.payment-price__hours .payment-price__how',
        'value': hours,
    }, {
        'selector': '.payment-price__minutes .payment-price__how',
        'value': minutes,
    }, {
        'selector': '.payment-price__seconds .payment-price__how',
        'value': seconds,
    }].forEach(function (e) {
        $(e.selector).html(e.value);
    });

    let condition = JSON.stringify([days, hours, minutes, seconds]);
    if ((condition === JSON.stringify(["00", "00", "00", "00"]))) {
        clearInterval(interval);
        localStorage.removeItem(type);
    }
}

function counterTime() {
    let type = null, countTime = null;
    if (Functions.getParameterByName('factor') !== null) {
        type = 'membership_time';
        countTime = new Date().getTime() + (500 * 3600 * 48);
    } else {
        type = 'trial_time';
        countTime = new Date().getTime() + (155 * 3600 * 48);
    }

    let time = localStorage.getItem(type);


    if (!time || isNaN(time) || new Date().getTime() >= time) {
        localStorage.setItem(type, countTime); // установить дату обратного отсчета
        time = localStorage.getItem(type);
    }

    getCountdown(time);

    setInterval(function () {
        getCountdown(time);
    }, 1000);
}

function getEmailInUrl() {
    let email = Functions.getParameterByName('email');
    if (email) {
        return email;
    }
    return false;
}

function checkEmpty(obj) {
    const name = $(obj).attr("name");
    $(`.${name}-validation`).html("");

    $(obj).css({
        "border": "",
        'box-shadow': 'inset 0 0 8px 0 rgba(33, 29, 30, 0.36)',
    });

    if($(obj).val() === "" || $(obj).val() == null) {
        $("."+name+"-validation").html("*Field is empty");
        $(obj).css({
            "border": "#FF0000 2px solid",
            'box-shadow': 'inset 0 0 8px 0 rgb(236, 16, 16)',
        });

        return false;
    }

    return true;
}

function checkEmail(obj) {
    let name = $(obj).attr("name");
    $(`.${name}-validation`).html("");
    $(obj).css({
        "border": "",
        'box-shadow': 'inset 0 0 8px 0 rgba(33, 29, 30, 0.36)',
    });

    let result = checkEmpty(obj);

    if(!result) {
        $(obj).css({
            "border": "#FF0000 2px solid",
            'box-shadow': 'inset 0 0 8px 0 rgb(236, 16, 16)',
        });

        $("."+name+"-validation").html("*Required field");
        return false;
    }

    let email_regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,3})+$/;
    result = email_regex.test($(obj).val());

    if(!result) {
        $(obj).css({
            "border": "#FF0000 2px solid",
            'box-shadow': 'inset 0 0 8px 0 rgb(236, 16, 16)',
        });
        $("."+name+"-validation").html("*Invalid email");
        return false;
    }

    return result;
}

function validate() {
    let valid = true;
    valid = valid && checkEmail($("input[name='email']"));

    if(valid) {
        $(".payment-form__submit").css('opacity', '1').attr("disabled",false);
        return true;
    } else {
        $(".payment-form__submit").css('opacity', '0.4').attr("disabled",true);
    }

    return false;
}

export default {
    init() {
        $(".payment-form__submit").css('opacity', '0.4').attr('disabled', 'disabled');
        counterTime();
    },

    finalize() {
        // JavaScript to be fired on the home page, after the init JS

      $('.language-selector__item').click(function () {
        if ($(this).hasClass('language-selector__item--selected')) {
          let parent = $(this).parent();

          if (parent.hasClass('language-selector--open')) {
            parent.removeClass('language-selector--open');
          } else {
            parent.addClass('language-selector--open');
          }
          return;
        }

        $(this).prependTo('.language-selector');
        $('.language-selector__item').removeClass('language-selector__item--selected');
        $('.language-selector').removeClass('language-selector--open');
        $(this).addClass('language-selector__item--selected');

        Translate.translatePayment();
      });

        $('.payment-form__input').on('change keyup paste', (() => {
            validate();
        }));

        $('.payment-form__radio-container').on('click', () => {
            let emailBlock = $('.payment-form__email');
            let inputEmail = $('.payment-form__input');

            if (!getEmailInUrl()) {
                emailBlock.fadeIn(800);
                $('.payment-divider').css({
                    'align-items': 'center',
                    'margin-bottom': '4%',
                    'width': '101px',
                });
                $('.payment-divider img').css({
                    'height': '59%',
                });
            } else {
                emailBlock.fadeOut();
                inputEmail.val(getEmailInUrl());
                $(".payment-form__submit").css('opacity', '1').removeAttr('disabled');
            }
        });

        $('.payment-form').submit((e) => {
            e.preventDefault();

            let costMembership = Functions.getParameterByName('factor');
            if (costMembership != null) {
                costMembership = '&factor=' + costMembership;
            } else {
                costMembership = '';
            }

            let card = $('.card-type:checked').val();

            if (validate()) {
                $(".payment-form :input").prop("disabled", true);
                if (card === 'Credimax') {
                    window.location.href = '//fitintimebahrain.com/payment-integrations/credimax/gateway.php?email=' + $('.payment-form__input').val() + costMembership;
                } else if (card === 'Benefit') {
                    window.location.href = '//fitintimebahrain.com/payment-integrations/benefits/init.php?email=' + $('.payment-form__input').val() + costMembership;
                }
            }
        });
    },
};

